import blogImg1 from "../../assets/images/insights/ai-manufacturing.webp";
import blogImg2 from "../../assets/images/insights/oil-gas.webp";
import blogImg3 from "../../assets/images/insights/digital-transformation-helthcare.webp";
import blogImg4 from "../../assets/images/insights/semiconductor.webp";
import blogImg5 from "../../assets/images/insights/digital-engineering.webp";
import blogImg6 from "../../assets/images/insights/smart-transportion.webp";

export const insightBlogs = [
  {
    id: 1,
    title: "The Future of AI in Manufacturing?",
    authorDetail: {
      date: "19 Feb 2024",
      name: "andrew",
    },
    text: "AI in manufacturing promises increased efficiency and innovation through smart automation and predictive maintenance, revolutionizing production processes and reducing costs.",
    path: "/",
    img: blogImg1,
    alt: "Sustainable Practices in the Oil & Gas Industry ?",
  },
  {
    id: 2,
    title: "Sustainable Practices in the Oil & Gas Industry ?",
    authorDetail: {
      date: "19 Feb 2024",
      name: "andrew",
    },
    text: "Adopting sustainable practices in the oil and gas industry minimizes environmental impact and promotes long-term resource efficiency through innovative technologies and strategies.",
    path: "/",
    img: blogImg2,
    alt: "Advancements in Semiconductor Technology ?",
  },
  {
    id: 3,
    title: "Digital Transformation in Healthcare ?",
    authorDetail: {
      date: "19 Feb 2024",
      name: "andrew",
    },
    text: "Digital transformation in healthcare improves patient care by utilizing advanced technologies to enhance efficiency and outcomes. Embracing digital tools allows healthcare providers to offer more personalized and timely services.",
    path: "/",
    img: blogImg3,
    alt: "Navigating Regulatory Compliance in the Finance Industry: A Technology Perspective ?",
  },
  {
    id: 4,
    title: "Advancements in Semiconductor Technology ?",
    authorDetail: {
      date: "19 Feb 2024",
      name: "andrew",
    },
    text: "Advancements in semiconductor technology are driving greater processing power and energy efficiency, paving the way for more powerful and sustainable electronic devices.",
    path: "/",
    img: blogImg4,
    alt: "Innovative Solutions in Aerospace and Defense: How VISTA Leads the Way ?",
  },

  {
    id: 5,
    title: "Digital Engineering ?",
    authorDetail: {
      date: "19 Feb 2024",
      name: "andrew",
    },
    text: "Digital engineering uses advanced technologies to optimize design, simulation, and manufacturing processes, driving innovation and efficiency while streamlining development and improving product performance.",
    path: "/",
    img: blogImg5,
    alt: "Navigating Regulatory Compliance in the Finance Industry: A Technology Perspective ?",
  },
  {
    id: 6,
    title: "The Role of IoT in Smart Transportation ?",
    authorDetail: {
      date: "19 Feb 2024",
      name: "andrew",
    },
    text: "IoT transforms transportation by enabling real-time data collection and analysis, improving traffic management, and enhancing vehicle safety while reducing congestion and streamlining road operations.",
    path: "/",
    img: blogImg6,
    alt: "The Future of Healthcare: Embracing Digital Transformation with VISTA ?",
  },
];
